export default __webpack_public_path__ + "static/media/steps.39423562.png";